import { useEffect, useMemo, useState } from "react";
import { MapContainer, TileLayer, WMSTileLayer, useMap } from "react-leaflet";

const GEOSERVER_NHADAM = "https://geoserver.cachinhbong.com/geoserver/NhaDam";
const CENTER_MAC_DINH = [11.988528, 108.933778];
const ZOOM_MAC_DINH = 10;

function ChangeView({ center, zoom }) {
  const map = useMap();
  useEffect(() => {
    map.setView(center, zoom);
    // dialog vừa mở nên container chưa có kích thước thật, phải báo leaflet đo lại
    // nếu không bản đồ sẽ hiện méo hoặc chỉ ra một mảnh xám
    const t = setTimeout(() => map.invalidateSize(), 200);
    return () => clearTimeout(t);
  }, [map, center, zoom]);
  return null;
}

/**
 * Bản đồ vùng trồng của một lô hàng.
 * @param {number[]} vungSanXuatIds danh sách Id vùng sản xuất gắn với lô hàng
 */
export default function MapVungTrong({ vungSanXuatIds }) {
  const [center, setCenter] = useState(CENTER_MAC_DINH);
  const [zoom, setZoom] = useState(ZOOM_MAC_DINH);

  const cqlFilter = useMemo(() => {
    if (!vungSanXuatIds || vungSanXuatIds.length === 0) return "";
    return vungSanXuatIds.map(id => `Id=${id}`).join(" or ");
  }, [vungSanXuatIds]);

  useEffect(() => {
    if (!cqlFilter) return;
    const url =
      `${GEOSERVER_NHADAM}/ows?service=WFS&version=2.0.0&request=GetFeature` +
      `&typeName=NhaDam:VungTrongNhaDam&outputFormat=application/json` +
      `&CQL_FILTER=${encodeURIComponent(cqlFilter)}`;

    let huy = false;
    fetch(url)
      .then(res => res.json())
      .then(data => {
        if (huy) return;
        const toaDo = data?.features?.[0]?.geometry?.coordinates;
        // chỉ nhận điểm dạng [lon, lat]; vùng dạng polygon thì giữ tâm mặc định
        if (Array.isArray(toaDo) && typeof toaDo[0] === "number") {
          setCenter([toaDo[1], toaDo[0]]);
          setZoom(16);
        }
      })
      // geoserver lỗi thì vẫn phải hiện bản đồ, không được để trắng
      .catch(() => {});

    return () => {
      huy = true;
    };
  }, [cqlFilter]);

  if (!cqlFilter) {
    return (
      <div
        style={{
          height: 320,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "#f5f5f5",
          color: "#7c7c7c",
          fontSize: 14
        }}
      >
        Lô hàng chưa gắn vùng sản xuất
      </div>
    );
  }

  return (
    <MapContainer
      scrollWheelZoom={true}
      zoomControl={true}
      maxZoom={18}
      minZoom={6}
      attributionControl={false}
      center={center}
      zoom={zoom}
      style={{ width: "100%", height: 320 }}
    >
      <ChangeView center={center} zoom={zoom} />
      <TileLayer url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png" />
      <WMSTileLayer
        maxZoom={30}
        layers={"NhaDam:VungTrongNhaDam"}
        params={{
          transparent: true,
          format: "image/png",
          tiled: true,
          version: "1.1.0",
          SRS: "EPSG:4326",
          CQL_FILTER: cqlFilter
        }}
        url={`${GEOSERVER_NHADAM}/wms`}
        crossOrigin="anonymous"
      ></WMSTileLayer>
    </MapContainer>
  );
}
